
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"clip-rule":"evenodd","fill":"currentColor","fill-rule":"evenodd","height":"18","stroke-linejoin":"round","stroke-miterlimit":"2","viewBox":"0 0 24 24","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 14a1 1 0 00-1-1H3a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1zm3 3h10a1 1 0 000-2H11a1 1 0 000 2zm-7-2v2h2v-2zm4-9a1 1 0 00-1-1H3a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1zM4 7v2h2V7zm7 2h10a1 1 0 000-2H11a1 1 0 000 2z"}})])
          )
        }
      }
    